<template>
  <div>
    <v-card
      color="red"
      flat
      tile
    >
      <v-toolbar dense
                 src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      ></v-toolbar>
    </v-card>
    <v-card class="d-flex align-center my-5 mx-8" elevation="0">
      <v-combobox
        :items="this.users"
        v-model="userId"
        :loading="selectLoading"
        :disabled="selectLoading"
        item-text="name"
        item-value="id"
        outlined
        placeholder="Vyberte uživatele"
        hide-details
        class="mr-3"
      ></v-combobox>
      <v-text-field
        placeholder="Uživatelské ID"
        label="Uživatelské ID"
        :disabled="selectLoading"
        outlined
        hide-details
        persistent-hint
        v-model="userId.id"
        class="mr-3"
      ></v-text-field>
      <v-btn
        color="green"
        dark
        @click="getUserInfo"
        :disabled="!userId.name"
        :loading="loading"
      >Vyhledat</v-btn>
    </v-card>
    <div
      class="ml-4"
      v-if="this.response[0]">
      Jméno: <span>{{this.response[0].firstName}}</span><br>
      Příjmení: <span>{{this.response[0].lastName}}</span><br>
      Email: <span>{{this.response[0].email}}</span>
    </div>
    <v-data-table
      ref="ordersTable"
      :loading="loading"
      :headers="orderHeaders"
      :items="orders"
      multi-sort
      sort-by="created"
      class="elevation-1 d-print-block"
      :sort-desc="true"
      locale="cs"
      :single-expand="singleExpand"
      show-expand
      :item-class="datatableRowBackground"
    >
      <template v-slot:item.description="{ item }">
        <v-chip
          v-if="item.description != null"
          color="green"
          dark
        >
          Ano
        </v-chip>
        <v-chip
          v-else
          color="red lighten-2"
          dark
        >
          Ne
        </v-chip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-container>
            <v-row>
              <table>
                <tbody>
                <tr>
                  <td style="font-weight: bold">
                    Strávníci:
                  </td>
                  <td
                    v-for="(boarder, index) in item.boarders" :key="index"
                  >
                    {{ boarder.firstName + ' ' + boarder.lastName + (index !== item.boarders.length - 1 ? ', ' : ' ') }}
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: bold">
                    Balení:
                  </td>
                  <td>
                    {{ item.customPackaging ? 'Vlastní nádoba' : 'Standardní balení' }}
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: bold">
                    Rozvoz:
                  </td>
                  <td>
                    {{ item.deliveryType }}
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: bold">
                    Poznámka:
                  </td>
                  <td>
                    {{ item.description }}
                  </td>
                </tr>
                </tbody>
              </table>
            </v-row>
            <v-row>
              <b>Obsah</b>
              <v-expansion-panels multiple>
                <v-expansion-panel
                  v-for="(day, dateStr, i) in item.items" :key="i"
                >
                  <v-expansion-panel-header>
                    <tr>
                      <th class="cart-heading">{{getLocalizedWeekDay(dateStr)}}</th>
                      <th class="cart-heading">{{getLocalizedDate(dateStr)}}</th>
                      <td class="cart-heading">{{getSelectedTimesStr(day)}}</td>
                    </tr>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-for="(time, index) in day"
                      :key="index"
                    >
                      <v-data-table
                        v-if="time.length"
                        :headers="historyHeaders"
                        :items="time"
                      >
                        <template v-slot:top>
                          <v-toolbar flat dense>
                            <v-toolbar-title>{{timeTypes.length ? timeTypes[index].name : ''}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>
                      </v-data-table>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-container>
        </td>
      </template>
    </v-data-table>
    <v-data-table
      :items-per-page="-1"
      :headers="transactionsHeaders"
      :items="transactions"
      :loading="loading"
    >
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'UserCard',
  data () {
    return {
      singleExpand: true,
      timeTypes: [],
      users: [],
      selectLoading: true,
      selectedUser: null,
      userId: '',
      loading: false,
      orders: [],
      transactions: [],
      response: [],
      diets: [],
      institutions: [],
      footerProps: { 'items-per-page-options': [25, 30, 50, 100, -1] },
      transactionsHeaders: [
        { text: 'ID', value: 'id', align: 'start', sortable: true },
        { text: 'Typ transakce', value: 'type', align: 'start', sortable: true },
        { text: 'Objednávka', value: 'orderId' },
        { text: 'E-mail admina', value: 'adminEmail' },
        { text: 'Poznámky', value: 'comment' },
        { text: 'Datum', value: 'createdStr' },
        { text: 'Částka', value: 'price' },
        { text: 'Stav', value: 'status' }
      ],
      orderHeaders: [
        { text: 'Číslo objednávky', value: 'id', align: 'start', sortable: true },
        { text: 'Poznámka', value: 'description' },
        { text: 'Datum vytvoření', value: 'created' },
        { text: 'Jídelníček', value: 'diet.name' },
        { text: 'Ulice', value: 'deliveryStreet' },
        { text: 'čp', value: 'deliveryStreetNumber' },
        { text: 'Město', value: 'deliveryCity' },
        { text: 'PSČ', value: 'deliveryZip' },
        { text: 'Zaplaceno', value: 'paidStr' },
        { text: 'Rozvoz', value: 'deliveryType' },
        { text: 'Celková cena', value: 'price' },
        { text: 'Způsob platby', value: 'paymentType' },
        { text: 'Stav', value: 'state' }
      ],
      historyHeaders: [
        { text: '', value: 'photo', sortable: false },
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'name',
          width: 300
        },
        { text: 'Alergeny', value: 'alergensStr' },
        { text: 'Kalorie', value: 'calories' },
        { text: 'Cena', value: 'price' },
        { text: '', value: 'data-table-expand' },
        { text: 'Množství', value: 'datatableQuantity' },
        { text: 'E-mail řidiče', value: 'driverMail' }
      ]
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.$http.get('/admin/roles/6')
        .then(response => {
          this.users = this.keysToCamelCase(response.data).map(user => {
            user.name = user.firstName + ' ' + user.lastName + '   ' + user.email
            return user
          })
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.selectLoading = false
        })
      this.$http.get('/admin/diets', { params: { slim: 1 } })
        .then(response => {
          this.diets = this.keysToCamelCase(response.data)
        })
        .catch(err => { console.log(err) })
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
        })
        .catch(err => console.log(err))
    },
    getUserInfo () {
      this.loading = true
      this.$http.get(`/user/last-info/${this.userId.id}`)
        .then(response => {
          this.response = this.keysToCamelCase(response.data)
          this.orders = this.response[1]
            .map(this.mapOrders).reverse()
          this.transactions = this.response[0].transactions
            .map(transaction => {
              switch (transaction.paymentTypeId) {
                case 1: transaction.type = 'Platba kreditem'; break
                case 3: transaction.type = 'Platba při převzetí'; break
                case 4: transaction.type = 'Platba bankovním převodem'; break
                case 5: transaction.type = 'Platba kartou'; break
                case 6: transaction.type = 'Dobití kreditu'; break
                case 7: transaction.type = 'Připsání kreditu'; break
                case 8: transaction.type = 'Vrácení kreditu'; break
                case 9: transaction.type = 'Dobropis'; break
              }
              const c = new Date(transaction.createdAt)
              transaction.createdStr = `${c.getDate()}.${c.getMonth() + 1}.${c.getFullYear()} ${c.getHours()}:${c.getMinutes()}:${c.getSeconds() < 10 ? '0' + c.getSeconds() : c.getSeconds()}`

              // checks DB errors
              transaction.userEmail = transaction.user ? transaction.user.email : ''
              transaction.userFullName = transaction.user ? `${transaction.user.firstName} ${transaction.user.lastName}` : ''
              transaction.adminEmail = transaction.admin ? transaction.admin.email : ''
              transaction.orderId = transaction.orderId || ''

              return transaction
            }).reverse()
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.loading = false
        })
    },
    mapOrders (order) {
      // order.dates = Object.keys(order.items)
      order.created = new Date(order.createdAt).toISOString().slice(0, 10)
      // order.created = new Date(order.createdAt).toLocaleDaresponsering('cs-cz')
      order.paidStr = order.paid ? 'Ano' : 'Ne'
      switch (order.paymentTypeId) {
        case 1: order.paymentType = 'Kredit'; break
        case 3: order.paymentType = 'Při převzetí'; break
        case 4: order.paymentType = 'Bankovní převod'; break
        case 5: order.paymentType = 'Kartou online'; break
      }
      for (const date in order.items) {
        order.items[date] = order.items[date].map(time => {
          time = time.map(item => {
            item.datatableQuantity = item.quantity * (order.boarders.length + +order.order)
            item.alergensStr = item.alergens
              .map(alergen => alergen.name)
              .join(', ')
            return item
          })

          return time
        })
      }
      return order
    },
    datatableRowBackground (item) {
      return item.state === 'Nezaplacená' ? 'red darken-1' : 'paid-order'
    },
    getLocalizedDate (dateStr) {
      const date = new Date(dateStr)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    getLocalizedWeekDay (dateStr) {
      const date = new Date(dateStr)
      const localeDayStr = date.toLocaleDateString('cs-cz', { weekday: 'long' })
      return localeDayStr[0].toUpperCase() + localeDayStr.slice(1)
    },
    getSelectedTimesStr (itemsArr) {
      let timeNames = []
      if (this.timeTypes.length) {
        timeNames = [0, 1, 2, 3, 4, 5]
          .map(time => this.timeTypes[time].name)
      }
      return timeNames
        .filter((time, index) => itemsArr[index].length)
        .join(', ')
    }
  }
}
</script>

<style scoped>
.container{
}
</style>
